import styled from "styled-components/native";

export const LinkText = styled.Text`
  color: #63b3ed;
`;
